module.exports = __webpack_public_path__ + "static/media/response_headers.d4693ee3.png";